<template>
  <div class="visits overFlowXauto">
    <div class="left-tree">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="right-content">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="setSearchParams"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>
	<!-- 成员列表 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'成员列表'"
      :visible.sync="dialogVisible1"
      width="50%"
      :before-close="handleClose1"
	  custom-class="alert-table-box"
    >
      <Table
        :width="'100%'"
        :templateData="tableTemplateData1"
        :tableConfig="tableConfig1"
      >
        <div class="btn-box">
          <el-button type="primary" @click="addMember" style="font-size: 12px"
            >添加成员</el-button
          >
        </div>
      </Table>
    </el-dialog>
    <!-- 添加成员 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'添加成员'"
      :visible.sync="dialogVisibleMember"
      width="500px"
      :before-close="handleCloseMember"
    >
      <editForm
        ref="editFormPlat"
        :formConfig="formConfig"
        :ruleForm="ruleForm"
        :rules="rules"
        :buttonConfig="buttonConfig"
      ></editForm>
    </el-dialog>
	<!-- 报警列表 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'报警列表'"
      :visible.sync="dialogVisible2"
      width="50%"
      :before-close="handleClose2"
	  custom-class="alert-table-box"
    >
      <Table
        :width="'100%'"
        :templateData="tableTemplateData2"
        :tableConfig="tableConfig2"
        :pagination="pagination2"
      >
      </Table>
    </el-dialog>
  </div>
</template>

<script>
import Tree from "../../../../components/Tree/nodeTree";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import { visitsApi } from "../../../../api-path/visits-circle.js";
export default {
  components: {
    Tree,
    TabelSearch,
  },
  data() {
    return {
      dialogVisibleMember: false,
      switchVal: false,
      tenDefenceId: "",
      //表格**********start
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "time",
            valueType: "date",
            placeholder: "选择创建时间",
          },
          {
            key: "search",
            valueType: "text",
            placeholder: "请输入名称/群主姓名/手机号搜索",
          },
        ],
      },
      searchParams: {
        areaId: "",
        isDown: false,
        time: "",
        search: "",
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [],
      tableTemplateData: [],
      tableConfig: {
        rows: [
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "联防小组名称",
            prop: "name",
          },
          {
            label: "群主",
            prop: "groupName",
          },
          {
            label: "群主电话",
            prop: "phone",
          },
          {
            label: "成员数量",
            prop: "members",
          },
          {
            label: "报警数量",
            prop: "alarmNum",
          },
          {
            label: "创建时间",
            prop: "createGmt",
          },
          {
            label: "状态",
            prop: "deleted",
            type: "status",
            activeText: "已解散",
            text: "正常",
          },
        ],
        rowButtons: {
          width: "250px",
          items: [
            {
              label: "成员",
              fn: (data) => {
                this.dialogVisible1 = true;
                this.tenDefenceId = data.id;
                this.$http
                  .get(visitsApi.queryMember, { params: { id: data.id } })
                  .then((res) => {
                    if (res.status == 200) {
                      this.tableTemplateData1 = res.result;
                    }
                  });
              },
            },
            {
              label: "报警",
              fn: (data) => {
                this.tenDefenceId = data.id;
                this.dialogVisible2 = true;
                this.searchParams2.page = this.pagination2.page=1;
                this.searchParams2.size = this.pagination2.size=15;
                this.searchParams2.tenDefenseId = data.id;
                this.setSearchParams2();
              },
            },
            {
              label: "解散",
              showkey: "disabled",
              type: "danger",
              fn: (data) => {
                this.$confirm("此操作将删除该群, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http
                      .get(visitsApi.del, { params: { id: data.id } })
                      .then((res) => {
                        if (res.status === 200) {
                          this.$message.success("删除成功");
                          this.setSearchParams();
                        }
                      });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消删除",
                    });
                  });
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      //***********表格end
      dialogVisible1: false,
      tableTemplateData1: [],
      tableConfig1: {
        rows: [
          {
            label: "姓名",
            prop: "userName",
          },
          {
            label: "电话",
            prop: "phone",
          },
          {
            label: "关系",
            prop: "relationType",
          },
          {
            label: "详细地址",
            prop: "address",
          },
          {
            label: "加入时间",
            prop: "createGmt",
          },
        ],
        rowButtons: {
          width: "150px",
          items: [
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.$confirm("此操作将删除该成员, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http
                      .get(visitsApi.memberDel, { params: { id: data.id } })
                      .then((res) => {
                        if (res.status == 200) {
                          this.$http
                            .get(visitsApi.queryMember, {
                              params: { id: this.tenDefenceId },
                            })
                            .then((res) => {
                              if (res.status == 200) {
                                this.tableTemplateData1 = res.result;
                              }
                            });
                        }
                      });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消操作",
                    });
                  });
              },
            },
          ],
        },
      },

      dialogVisible2: false,
      tableTemplateData2: [],
      searchParams2: {
        tenDefenseId: "",
        page: 1,
        size: 15,
      },
      tableConfig2: {
        rows: [
          {
            label: "报警人",
            prop: "name",
          },
          {
            label: "报警时间",
            prop: "createGmt",
          },
          {
            label: "报警内容",
            prop: "content",
          },
        ],
        rowButtons: {},
      },
      pagination2: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange2,
        pageChange: this.pageChange2,
      },
      // 添加成员
      ruleForm: {
        address: "",
        id: "",
        phone: "",
        relationType: "",
        tenDefenceId: "",
        userName: "",
      },
      formConfig: {
        disabled: false,
        ref: "editFormIP",
        items: [
          [
            {
              valueType: "input", // 类型
              label: "姓名",
              key: "userName", // 数据名称
              prop: "userName", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "50%",
              placeholder: "请输入姓名", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "电话",
              key: "phone", // 数据名称
              prop: "phone", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "50%",
              placeholder: "请输入电话", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "关系",
              key: "relationType", // 数据名称
              prop: "relationType", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "50%",
              placeholder: "请输入关系", // 提示信息
            },
          ],
          [
            {
              valueType: "input", // 类型
              label: "地址",
              key: "address", // 数据名称
              prop: "address", // 验证规则
              labelWidth: "100px", // label 宽度
              maxlength: "50",
              itemWidth: "50%",
              placeholder: "请输入详细地址", // 提示信息
            },
          ],
        ],
      },
      rules: {
        userName: [
          {
            required: true,
            trigger: "change",
            message: "请输入正确的姓名",
          },
        ],
        phone: [
          {
            required: true,
            trigger: "change",
            pattern: /(^$)|^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "请输入正确的电话号码",
          },
        ],
        relationType: [
          {
            required: true,
            trigger: "change",
            message: "请输入正确的关系",
          },
        ],
        address: [
          {
            required: true,
            trigger: "change",
            message: "请输入正确的地址",
          },
        ],
      },
      buttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              this.ruleForm = data;
              this.ruleForm.tenDefenceId = this.tenDefenceId;
              this.$http.post(visitsApi.memberSave, this.ruleForm).then((res) => {
                if (res.status === 200) {
                  this.$message({
                    type: "success",
                    message: "添加成功!",
                  });
                  this.dialogVisibleMember = false;
                  this.$http
                    .get(visitsApi.queryMember, { params: { id: this.tenDefenceId } })
                    .then((res) => {
                      if (res.status == 200) {
                        this.tableTemplateData1 = res.result;
                      }
                    });
                }
              });
            },
          },
        ],
      },
    };
  },
  methods: {
    //添加成员start
    addMember() {
      this.dialogVisibleMember = true;
    },
    handleCloseMember() {
      this.dialogVisibleMember = false;
    },
    handleClose1() {
      this.dialogVisible1 = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    // 每页显示条数
    sizeChange2(size) {
      this.pagination2.size = size;
      this.searchParams2.size = size;
      this.setSearchParams2();
    },
    // 当前页
    pageChange2(page) {
      this.pagination2.page = page;
      this.searchParams2.page = page;
      this.setSearchParams2();
    },
    setSearchParams2() {
      this.$http.get(visitsApi.detail, { params: this.searchParams2 }).then((res) => {
        if (res.status == 200) {
          this.tableTemplateData2 = res.result.pageList;
          this.pagination2.total = res.result.total;
        }
      });
    },
    changeSwitch(e) {
      this.switchVal = e;
      this.searchParams.isDown = e;
      this.setSearchParams();
    },
    nodeClick(node) {
      this.areaId = node.id;
      this.searchParams.areaId = node.id;
      this.setSearchParams();
    },
    resetCallBack() {
      this.searchParams.time = "";
      this.searchParams.search = "";
      this.searchParams.page = this.pagination.page=1;
      this.searchParams.size = this.pagination.size=15;
      this.searchParams.areaId = this.areaId;
      this.searchParams.isDown = this.isDown;
      this.setSearchParams();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.setSearchParams();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.setSearchParams();
    },
    setSearchParams() {
      this.$http
        .get(visitsApi.queryListByPage, { params: this.searchParams })
        .then((res) => {
          if (res.status === 200) {
            let result = res.result.pageList;
            result.map((item) => {
              item.disabled = !item.deleted;
            });
            this.tableTemplateData = result;
            this.pagination.total = res.result.total;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.visits {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  .left-tree {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .right-content {
	flex: 1;
	display: flex;
	flex-direction: column;
  }
}
</style>
